import { render } from "./accountModal.vue?vue&type=template&id=3be6caae&scoped=true&ts=true"
import script from "./accountModal.vue?vue&type=script&lang=ts"
export * from "./accountModal.vue?vue&type=script&lang=ts"

import "./accountModal.vue?vue&type=style&index=0&id=3be6caae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be6caae"]])

export default __exports__